const translations = {
    title: 'Faults'
};

export default translations;
